import React from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft } from "lucide-react";
import { SafeHTML } from "@/components/site/RichTextEditor";
import ShareReactBar from "@/components/site/ShareReactBar";

export default function NewsDetail() {
  const { slug } = useParams();
  const [art, setArt] = React.useState(null);
  const [notFound, setNotFound] = React.useState(false);

  React.useEffect(() => {
    api.get(`/articles/${slug}`).then((r) => setArt(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16"><h1 className="font-display font-black text-3xl">Article introuvable</h1><Link to="/actualites" className="neo-btn bg-cef-yellow mt-4 inline-flex">← Retour</Link></div>;
  if (!art) return <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">Chargement...</div>;

  // Detect HTML vs plain text (HTML produced by RichTextEditor starts with a tag)
  const isHTML = (art.content || "").trim().startsWith("<");

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="article-detail">
      <Link to="/actualites" className="inline-flex items-center gap-2 text-sm font-bold hover:underline mb-6" data-testid="back-to-news"><ArrowLeft className="w-4 h-4" /> Toutes les actualités</Link>
      <span className="chip bg-cef-yellow">{art.category}</span>
      <h1 className="mt-3 font-display font-black text-3xl sm:text-5xl tracking-tighter leading-tight" data-testid="article-title">{art.title}</h1>
      <div className="mt-3 text-sm text-neutral-500">{art.author} · {new Date(art.published_at).toLocaleDateString("fr-BE")}</div>
      {art.image_url && <img src={art.image_url} alt={art.title} className="mt-6 w-full border-2 border-black rounded-md shadow-brutal" />}
      <div className="mt-8" data-testid="article-content">
        {isHTML ? <SafeHTML html={art.content} className="prose-lg" /> : <div className="prose max-w-none text-lg leading-relaxed whitespace-pre-wrap">{art.content}</div>}
      </div>
      {art.tags?.length > 0 && (
        <div className="mt-8 flex flex-wrap gap-2">
          {art.tags.map((t) => <span key={t} className="chip bg-white">#{t}</span>)}
        </div>
      )}

      <ShareReactBar title={art.title} kind="Article" />
    </article>
  );
}
